import { Theme } from '@mui/material/styles';
import { withStyles, createStyles } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Drawer, DialogTitle, IconButton, DialogContent } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import classnames from 'classnames';
import APSlidingRightPanelConatinerStyles from './styles/APSlidingRightPanelContainer.style';
import { withTranslate } from "../../core/TenantProvider";
import BankDetailsContainer from "../BankDetailsContainer";
import TrackingCodeContainer from "../TrackingCodeContainer";
import ResourceItemContainer from "../ResourcesItemContainer";
import POIDocumentsContainer from "../POIDocumentsContainer";
import ReferralFormContainer from "../ReferralFormContainer";
import { connect } from 'react-redux';
import { ReducerState } from '../../redux/modules';
import { actions as SlidingRightPanelActions } from '../../redux/modules/uistates';
import { bindActionCreators, Dispatch } from 'redux';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        slidingRightPanelWrapper: {
            "& .MuiDrawer-paperAnchorRight": {
                maxWidth: 690,
                width: '85%',
                boxShadow: "-15px 0 15px 0 rgba(0, 0, 0, 0.08)",
                backgroundColor: "#F5F5F5",
                zIndex: 1300,
                '@media(max-width: 480px)': {
                    width: '100%',
                },
            },
            '&.lg .MuiDrawer-paperAnchorRight': {
                maxWidth: 850,
                width: '85%',
                '@media(max-width: 480px)': {
                    width: '100%',
                },
            },
            "& .MuiDialogContent-root": {
                paddingRight: '65px',
                paddingLeft: '65px',
                [theme.breakpoints.down('lg')]: {
                    paddingRight: '16px',
                    paddingLeft: '16px',
                }
            },
            '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(255,255,255,0.75)'
            }
        },
        slidingRightPanelWrapperPDF: {
            '&.lg .MuiDrawer-paperAnchorRight': {
                maxWidth: 1315,
                width: '90%',
                '@media(max-width: 480px)': {
                    width: '100%',
                },
            }
        },
        slidingRightPanelTitle: {
            display: "flex",
            justifyContent: "flex-end",
            // padding: "0 !important"
        },
    })
);

function APSlidingRightPanelContainer(props: any) {
    const classes = useStyles();
    const { rightPanelComponent, rightPanelComponentData } = props;
    const closeSlidingRightPanel = () => {
        props.toggleSlidingRightPanelStatus(false, '');
    };

    const keyTimeStamp = Math.random().toString();

    const slidingRightPanelWrapper = classnames(classes.slidingRightPanelWrapper, {
        ['lg']: rightPanelComponent === 'resourceItem' || rightPanelComponent === 'trackingCode',
        [classes.slidingRightPanelWrapperPDF]: rightPanelComponentData?.file_type === 'pdf'
    });

    return (
        <Drawer anchor="right" open={props.rightPanelState} onClose={closeSlidingRightPanel}
            className={slidingRightPanelWrapper}
            ModalProps={{ onBackdropClick: closeSlidingRightPanel }}
        >
            <div>
                <DialogTitle className={classes.slidingRightPanelTitle}>
                    <IconButton onClick={closeSlidingRightPanel} size="large">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {props.rightPanelComponent === 'bankDetails' && (<BankDetailsContainer />)}
                    {props.rightPanelComponent === 'trackingCode' && (<TrackingCodeContainer />)}
                    {props.rightPanelComponent === 'resourceItem' && (<ResourceItemContainer />)}
                    {props.rightPanelComponent === 'poiDocuments' && (<POIDocumentsContainer />)}
                    {props.rightPanelComponent === 'referralForm' && (<ReferralFormContainer key={keyTimeStamp} />)}
                </DialogContent>
            </div>
        </Drawer>
    );
}

const mapStateToProps = (store: ReducerState) => ({
    rightPanelState: store.uiStates.isOpen,
    rightPanelComponent: store.uiStates.component,
    rightPanelComponentData: store.uiStates.componentData,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    toggleSlidingRightPanelStatus: SlidingRightPanelActions.toggleSlidingRightPanelStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(
    withStyles(APSlidingRightPanelConatinerStyles)(APSlidingRightPanelContainer)
));